const classConcat = (defaultClass, customClass) => {
  if (customClass) {
    return [defaultClass, customClass].join(' ');
  }
  return defaultClass;
};

export default classConcat;
